import {
    INITIALIZE_PAYLOAD,
    INITIALIZE_ERROR,
    INIT_GOOGLE_COURSE_ID,
    STARTPAGE_CHECKBOX_CLICK,
    TOGGLE_HINTBOX,
    PROFILE_NAME,
} from '../actions/application';
import { SOURCES_WITH_THEORIES } from '../config';

const initialState = {
    assignmentId: null,
    originalId: null,
    showStartPage: false,
    isPreview: false,
    saveStatus: false,
    name: 'Allenamento',
    shuffle: true,
    pauseTest: false,
    repeatTest: 0,
    encodedPayload: '',
    showSuggestions: false,
    singleAnswer: false,
    time: undefined,
    source: null,
    status: {
        completed: false,
        error: false,
    },
    appLoaded: {
        pending: true,
        completed: false,
        error: false,
    },
    closedHintBox: [],
    loadTheories: false,
    executionMode: null,
    isLtiLaunch: false,
    isOpenAssignment: false,
    groupCorrectionByTopic: null,
    mode: '',
    firstPage: '',
    disableLeavePopup: false,
    platform: null,
};

export function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case INITIALIZE_PAYLOAD:
            return {
                ...state,
                ...action.payload,
                showResults: false,
                status: {
                    completed: true,
                    error: false,
                },
                loadTheories: SOURCES_WITH_THEORIES.indexOf(action.payload.source) > -1,
                isLtiLaunch: state.isLtiLaunch || !!action.isLtiLaunch,
                isOpenAssignment: !!action.payload.lazeUser,
                platform: action.platform,
            };
        case INITIALIZE_ERROR:
            return {
                ...state,
                status: {
                    ...state.status,
                    error: true,
                },
                isLtiLaunch: state.isLtiLaunch || !!action.isLtiLaunch,
            };
        case STARTPAGE_CHECKBOX_CLICK:
            return {
                ...state,
                showStartPage: action.payload,
            };
        case TOGGLE_HINTBOX: {
            const exerciseType = action.payload;
            const idx = state.closedHintBox.indexOf(exerciseType);
            if (idx > -1) {
                state.closedHintBox.splice(idx, 1);
                return {
                    ...state,
                };
            } else {
                return {
                    ...state,
                    closedHintBox: [...state.closedHintBox, exerciseType],
                };
            }
        }
        case INIT_GOOGLE_COURSE_ID:
            return { ...state, googleCourseWorkId: action.payload };
        case PROFILE_NAME:
            return { ...state, name: action.payload };
        default:
            return state;
    }
}
